module.exports = __webpack_public_path__ + "static/img/appleDes.f7063b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appleDes.png
// module id = d541a49ef1f981fe
// module chunks = 59